import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import $api from "@/zapi-frontend/shared/api/axios";
import { AxiosError } from "axios";

type DeleteOrganizationLogoParams = {
  organizationId: number;
};

export function useDeleteOrganizationLogo(
  options?: UseMutationOptions<void, AxiosError<{ message: string }>, DeleteOrganizationLogoParams>
) {
  return useMutation({
    mutationKey: ["delete-organization-logo"],
    mutationFn: async ({ organizationId }: DeleteOrganizationLogoParams) => {
      await $api.delete(`/organizations/${organizationId}/logo`);
    },
    ...options
  });
}
